<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import PAF02 from './PAF02.vue'


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ PAF02 ],
    computed: {
      itemsSuperRainbowSkyIR () {
        const index = _.findIndex(this.items, { id: 'IR04-16' })
        return this.items.slice(index, index + 4)
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリリズDMFCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRDMFCh', 'ER')" />
      <ItemList title="プリリズDMFCh|PR ★★★" color="#ffa1bc" :items="collection('PRDMFCh', 'PR')" />
    </template>

    <template #col2>
      <ItemList title="プリリズDMFCh|SR ★★" color="#00c7da" :items="collection('PRDMFCh', 'SR')" />
      <ItemList title="プリリズDMFCh|R ★" color="#feab0d" :items="collection('PRDMFCh', 'R')" />
    </template>

    <template #col3>
      <ItemList title="ドリームパレードCh|🥚 ER 🥚" color="#44cd1f" :items="collection('DreamParadeCh', 'ER')" />
      <ItemList title="ドリームパレードCh|PR ★★★" color="#ffa1bc" :items="collection('DreamParadeCh', 'PR')" />
    </template>

    <template #col4>
      <ItemList title="ドリームパレードCh|SR ★★" color="#00c7da" :items="collection('DreamParadeCh', 'SR')" />
    </template>

    <template #col5>
      <ItemList title="プリティーコレクション2|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection2', 'PR') | first(9 * 4)" />
    </template>

    <template #col6>
      <ItemList title="プリティーコレクション2|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection2', 'PR') | rest(9 * 4)" :isOrphan="true" />
      <ItemList title="プリティーコレクション2|ニコチケ SR ★★" color="#00c7da" :items="collection('PrettyCollection2', 'SR')" />
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="itemsSuperRainbowSkyIR" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

    <template #col7>
    </template>

    <template #col8>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
